var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client';
import { EsigningRecipientType } from 'shared/domains/apollo/generated/types';
import { GetEsigningRecipientsDocument } from './query.gql';
import { useEsigning } from '../../components/EsigningProvider';
export const useEsigningRecipients = () => {
    var _a;
    const { documentId } = useEsigning();
    const _b = useQuery(GetEsigningRecipientsDocument, {
        variables: { documentId },
    }), { data } = _b, rest = __rest(_b, ["data"]);
    const esigningRecipients = ((_a = data === null || data === void 0 ? void 0 : data.fileSystemDocument) === null || _a === void 0 ? void 0 : _a.esigningRecipients) || [];
    const allRecipients = esigningRecipients.map((recipient) => ({
        id: recipient.id,
        type: recipient.type,
        name: recipient.name,
        email: recipient.email,
        firstName: recipient.firstName || undefined,
        lastName: recipient.lastName || undefined,
        label: recipient.label || undefined,
        message: recipient.message || undefined,
        mobile: recipient.mobile || undefined,
        title: recipient.title || undefined,
        status: recipient.status || undefined,
        authenticationMode: recipient.authenticationMode || undefined,
        order: recipient.order === null || recipient.order === undefined || recipient.order === -1 ? undefined : recipient.order,
    }));
    const signerRecipients = allRecipients.filter(({ type }) => type === EsigningRecipientType.Signatory);
    const viewerRecipients = allRecipients.filter(({ type }) => type === EsigningRecipientType.Viewer);
    return Object.assign(Object.assign({}, rest), { signerRecipients, viewerRecipients, allRecipients });
};
